import React from 'react';
import { useDispatch } from 'react-redux';
import { useIntercom } from 'react-use-intercom';
import { Link } from '@material-ui/core';
import { sendEventToGTM } from '@dev/ee-tools';
import { TertiaryButton, Typography, WebsitePrimaryButton, CheckIcon, palette } from '@dev/ee-components';
import { Trans, useTranslation } from 'react-i18next';
import useMobile from '@/services/hooks/useMobile';
import { links } from '@/services/dictionaries/links';
import OnboardingSuccessImage from '@/images/onboarding-success.svg';
import { isCustomBranding } from '@/services/Secuirty';
import { FinishOnboarding } from '@/store/onboarding/actions';
import {
    ButtonsWrapper,
    ContentWithCheckbox,
    ContentWithCheckboxWrapper,
    GridColumns,
    HeaderTextWrapper,
    LeftColumnWrapper,
} from './styles';

export const OnboardingFinishedInfo = (): JSX.Element => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { show } = useIntercom() || {};
    const isMobie = useMobile();

    const onCloseOnboarding = (): void => {
        dispatch(FinishOnboarding());
        sendEventToGTM('onboarding_completed');
    };

    const launchIntercom = () => {
        !isCustomBranding() && show();
    };

    return (
        <GridColumns $isMobile={isMobie}>
            <LeftColumnWrapper>
                <HeaderTextWrapper>
                    <Typography variant="h2">{t('congratulationsfinishonboarding')}</Typography>
                    <Typography variant="body1">{t('youareallsettostartexploring')}</Typography>
                </HeaderTextWrapper>
                <ContentWithCheckboxWrapper>
                    <ContentWithCheckbox>
                        <CheckIcon color={palette.teal[4]} />
                        <Typography variant="body1">{t('ifyouneedanyassistance')}</Typography>
                    </ContentWithCheckbox>
                    <ContentWithCheckbox>
                        <CheckIcon color={palette.teal[4]} />
                        <Typography variant="body1">
                            <Trans
                                i18nKey="tomakethemostofyouremailexperience"
                                components={{ url: <Link href={links.deliveryGuide} target="_blank" /> }}
                            />
                        </Typography>
                    </ContentWithCheckbox>
                </ContentWithCheckboxWrapper>
                <ButtonsWrapper>
                    <WebsitePrimaryButton text={t('closeonboarding')} onClick={onCloseOnboarding} />
                    <TertiaryButton text={t('contactsupport')} onClick={launchIntercom} />
                </ButtonsWrapper>
            </LeftColumnWrapper>
            {!isMobie && (
                <div>
                    <OnboardingSuccessImage />
                </div>
            )}
        </GridColumns>
    );
};
